import { Spin } from "antd";
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

const SingleCollaborator = ({
  item,
  onAdd,
  onRemove,
  isSelected,
  isLoading,
  isCollaborator,
}) => {
  const handleCollaboratorClick = () => {
    if (isCollaborator) {
      onRemove(item);
    } else {
      onAdd(item);
    }
  };
  return (
    <div className="d-single_colaborator_container">
      <div className="single_colaborator_left">
        <p className="colaborator_title">{item.first_name}</p>
        <p className="colaborator_email">{item.email}</p>
      </div>
      <div className="single_colaborator_right">
        <div
          className="single_colaborator_right_button"
          onClick={handleCollaboratorClick}
        >
          {isLoading ? (
            <Spin
              indicator={
                <LoadingOutlined
                  spin
                  style={{
                    fontSize: "14px", // Make the spinner larger
                    color: "#20c3ff", // Ensure good visibility
                  }}
                />
              }
            />
          ) : isCollaborator ? (
            "Remove"
          ) : (
            "Add"
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleCollaborator;
